module.exports = __webpack_public_path__ + "static/media/materialize.a0b22529.png";